module.exports = __webpack_public_path__ + "media/images/icons/flags/KY-5c9d0cf6a3fa2a9f48df92bfc811dcb9.svg";